import { isAppleDevice } from "..";
import { BASE_URL } from "../url";
import { isBannoServiceProvider, isCornerstoneTenant, isTinkerTenant } from "./banno";
import { isCsiServiceProvider } from "./csi";
import { isLuminServiceProvider } from "./lumin";
import { cardControlsRedirectQ2, isCamdenTenant, isQ2ServiceProvider } from "./q2";

export const homeRedirectTenantWise = (props, fromProps = true) => {
    if (isQ2ServiceProvider(props, fromProps)) {
        if (window.tecton && window.tecton.actions) {
            window.tecton.actions.navigateTo('dashboard')
        } else {
            console.log(`tecton not able to navigate`)
        }

    }

    if (isBannoServiceProvider(props, fromProps) && window.parent.banno) {
        if (
            typeof window !== "undefined" &&
            window.Bridge &&
            typeof window.Bridge.requestClose === "function"
        ) {
            window.Bridge.requestClose();
        }
        window?.parent?.banno?.redirectToHome();
    }

    if (isCsiServiceProvider(props, fromProps) || isLuminServiceProvider(props, fromProps)) {
        window.location.href = '/parent/tenant/enrollment';
    }
}

export const cardControlsRedirect = (props, childProfile = null) => {
    const childId = props.location?.state?.childId
        || childProfile?.wardId
        || props.state?.user?.family?.wards?.find(e => e.isPending === false)?.wardId;

    if (isQ2ServiceProvider(props)) {
        return cardControlsRedirectQ2(props);
    } else if (isBannoServiceProvider(props)) {
        const tenantName = props?.state?.theme?.values?.tenantFullName;
        const spendingLinks = props?.state?.spendingcontrol?.[tenantName];

        const redirectUrl = isAppleDevice()
            ? spendingLinks?.parent?.apple
            : spendingLinks?.parent?.google;

        if (redirectUrl) {
            window.parent.location.href = redirectUrl;
        }
    } else if (childId) {
        props.history.push({ pathname: `/parent/children/setting`, search: "?type=spending", state: { ...props.state, childId, childProfile: childProfile } });
    }
}

export const isInvestmentEnable = (featureTogglesResponse) => {
    //console.log(featureTogglesResponse);
    return (featureTogglesResponse.find(e => e === 'InvestmentsOnly') ? false : true);
}

export const gotoAddChildScreen = (props) => {
    props.history.push(getAddChildRoute(props));
};

export const getAddChildRoute = (props) => {
    if (isBannoServiceProvider(props) || isLuminServiceProvider(props)) {
        return '/parent/linkExistingChild';
    }
    return '/parent/children/add';
};